import eventBus from '@/plugins/event-bus.js';

export const useEventBus = () => {
    return {
        emit: (eventName: string, data?: any): void => { eventBus.$emit(eventName, data); },
        on: (event: string | string[], callback: any): void => { eventBus.$on(event, callback); },
        off: (event?: string | string[], callback?: any): void => { eventBus.$off(event, callback); },
    };
};
